import { HtmlEntityType } from './icon.utils';

export class IconHelper {

    static getIconElement(htmlEntity: HtmlEntityType) {
        return <span dangerouslySetInnerHTML={{ __html: htmlEntity }}></span>
    }
}